import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// material-ui
import { ButtonBase } from '@mui/material';

// project import
// import LogoMain from './LogoMain';
// import LogoIcon from './LogoIcon';
import { APP_DEFAULT_PATH } from 'config';
// import LogoServicepack from 'assets/images/common/ServicePackSmallLogo.svg';
// import MainServicepackLogo from 'assets/images/common/ServicePackFullLogo.svg';
// import ServicepackWhiteSmallLogo from 'assets/images/common/ServicepackWhiteSmallLogo.svg';
// import ServicepackWhiteFullLogo from 'assets/images/common/ServicepackWhiteFullLogo.svg';

// import { useTheme } from '@mui/styles';
import FullScreen from './ExpFull';
import IconShort from './ExpShort';

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = ({ isIcon, sx, to }) => {
  // const theme = useTheme();
  return (
    <ButtonBase disableRipple component={Link} to={!to ? APP_DEFAULT_PATH : to} sx={{ ...sx }}>
      {isIcon ? <IconShort /> : <FullScreen />}
    </ButtonBase>
  );
};

LogoSection.propTypes = {
  reverse: PropTypes.bool,
  isIcon: PropTypes.bool,
  sx: PropTypes.object,
  to: PropTypes.string
};

export default LogoSection;
